import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-couponTriangleDisabled",
  "use": "icon-couponTriangleDisabled-usage",
  "viewBox": "0 0 4 4",
  "content": "<symbol viewBox=\"0 0 4 4\" fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-couponTriangleDisabled\">\n<path d=\"M4 0H0L4 4V0Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol